import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class MeteoService {
  private http = inject(HttpClient);

  /** Inserted by Angular inject() migration for backwards compatibility */
  constructor(...args: unknown[]);


  constructor() { }

  getUrlInfoAemet(nombreProvincia: string, idMunicipio: string){
    //var headers = {'Content-Type':'application/json', 'Accept':'application/json', 'Cache-Control':'no-cache'};
    return this.http.get('https://www.el-tiempo.net/api/json/v2/provincias/'+ nombreProvincia +'/municipios/'+ idMunicipio)
    //return this.http.get("https://opendata.aemet.es/opendata/api/prediccion/especifica/municipio/diaria/"+idMunicipio+"?api_key=eyJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJhbW9yYWxAYW1zeXN0ZW0uZXMiLCJqdGkiOiJhNWJmMmQzOS03OGU1LTQ4NzYtYmM0NS1mODZhODc5ZThmYmUiLCJpc3MiOiJBRU1FVCIsImlhdCI6MTYyNDg3NDYzMiwidXNlcklkIjoiYTViZjJkMzktNzhlNS00ODc2LWJjNDUtZjg2YTg3OWU4ZmJlIiwicm9sZSI6IiJ9.AwWdElWb3PYUstC1QnBRWUywPZlWbO_lCTjE1LVoMBg")
  }
}
